<template>
  <div class="calico-understand-betascore-dialog-page">
    <button
      class="button-primary"
      @click="open = true"
    >
      Open “Understand the BetaScore”
    </button>
    <UnderstandBetascoreDialog
      v-if="open"
      @close="open = false"
    />
  </div>
</template>

<script>
import UnderstandBetascoreDialog from '@/components/pattern/understandBetascoreDialog/index.vue'

export default {
  name: 'CalicoUnderstandBetascoreDialogPage',
  components: { UnderstandBetascoreDialog },
  data: () => ({
    open: true
  })
}
</script>

<style lang="scss">
.calico-understand-betascore-dialog-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);
  @include inset-space($space-medium);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
